<div class="ba-row text-center ba-spacing-top-h3">
    <ba-feedback client-id="c801060a-fc01-4221-bc75-f9e34803510b" subject="{{'mailbox.feedback-subject' | i18next}}">
        <p slot="header" class="h3">{{'mailbox.feedback' | i18next}}</p>
    </ba-feedback>
</div>
